/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon24Regular = forwardRef('MailIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.742 7.934a.75.75 0 1 0-.984 1.132l3.781 3.288a3.75 3.75 0 0 0 4.922 0l3.781-3.288a.75.75 0 1 0-.984-1.132l-3.782 3.288a2.25 2.25 0 0 1-2.952 0L6.742 7.934Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4.25A3.75 3.75 0 0 0 2.25 8v8A3.75 3.75 0 0 0 6 19.75h12A3.75 3.75 0 0 0 21.75 16V8A3.75 3.75 0 0 0 18 4.25H6ZM3.75 8A2.25 2.25 0 0 1 6 5.75h12A2.25 2.25 0 0 1 20.25 8v8A2.25 2.25 0 0 1 18 18.25H6A2.25 2.25 0 0 1 3.75 16V8Z" })));
});
